import React from 'react';
import { useEffect } from 'react';

function Home() {
    // redirect to https://www.egadiescursioni.it/
    useEffect(() => {
        window.location.href = "https://www.egadiescursioni.it/";
    }, []);

  /*useEffect(() => {
    const script = document.createElement('script');
  
    script.src = "generatorV.js";
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    }
  }, []);

*/
  return (
    <div className="tourmaster-page-wrapper tourmaster-payment-style-1 tourmaster-template-payment" id="tourmaster-page-wrapper">
        <div className="tourmaster-template-wrapper" id="tourmaster-payment-template-wrapper">
          <div className="tourmaster-container">
            <div className="tourmaster-page-content tourmaster-item-pdlr clearfix">
                <div id="EE_widget" tourid="60630b50d98edd0e746ab308"></div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default Home;